<template>
  <div class="sorting">
    <div class="sorting__title">
      {{ title }}
    </div>
    <div v-if="sort" class="sorting__buttons">
      <button
        v-for="(item, index) in sort"
        :key="index"
        :class="{ active: item.value === isActive }"
        type="button"
        @click="selectThis(item.value)"
      >
        {{ item.name }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    sort: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    activeValue: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    isActive: {
      get() {
        return this.sort && this.sort.length && this.activeValue === null
          ? this.sort[0].value
          : this.activeValue;
      },
      set(val) {
        console.log(val);
      },
    },
  },
  methods: {
    selectThis(val) {
      this.isActive = val;
      this.$emit("changePoint", val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.sorting {
  display: flex;
  border-bottom: 1px solid $border;

  &__title {
    font-size: 1.2rem;
    color: $light_gray;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    margin-right: 2rem;
  }

  &__buttons {
    display: flex;
    align-items: center;

    button {
      position: relative;
      background: transparent;
      border: none;
      border-radius: 0;
      box-shadow: none;
      font-weight: 700;
      font-size: 1.2rem;
      text-transform: uppercase;
      color: $text;
      height: 100%;
      display: inline-flex;
      transition: $hoverAnim;

      &:hover {
        opacity: 0.7;
      }

      &:not(:last-child) {
        margin-right: 2rem;
      }

      &::before {
        content: "";
        opacity: 0;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background-color: $text;
        display: block;
        transform: translateY(75%);
        z-index: 3;
        transition: $hoverAnim;
      }

      &::after {
        content: "";
        opacity: 0;
        position: absolute;
        left: 50%;
        top: 100%;
        bottom: 0;
        transform: translateX(-50%);
        border: 1rem solid transparent;
        border-top: 0.6rem solid $text;
        transition: $hoverAnim;
      }

      &.active {
        &::before,
        &::after {
          opacity: 1;
        }
      }
    }
  }
}
</style>
